<!--模板控件-->
<template>
	<div v-if="selectIndex != -1" class="control_div">
		<div class="row">
			<span class="span">删除控件：</span>
			<i class="el-icon-delete" @click="deleteClick(TemplateList[selectIndex].templateType)"></i>
		</div>
		<div class="row">
			<span class="span">控件类型：</span>
			<span>{{list[TemplateList[selectIndex].templateType]}}</span>
		</div>
		<div class="row">
			<span class="span">控件名称：</span>
			<el-input class="input" :placeholder="TemplateList[selectIndex].name"
				v-model="TemplateList[selectIndex].name" />
		</div>
		<div class="row">
			<span class="span">说明提示：</span>
			<el-input class="input" :placeholder="TemplateList[selectIndex].placeholder"
				v-model="TemplateList[selectIndex].placeholder" />
		</div>
		<div class="row">
			<span class="span">控件排序：</span>
			<div v-if="(TemplateList.length - 1) > selectIndex" class="icon_div">
				<i class="el-icon-bottom" @click="down()"></i>
			</div>
			<div v-if="selectIndex != 0" class="icon_div">
				<i class="el-icon-top" @click="up()"></i>
			</div>
		</div>
		<div v-if="TemplateList[selectIndex].templateType == 2" class="row_">
			<span class="span">内容选项：</span>
			<div class="col">
				<div class="item_div" v-for="(item,index) in TemplateList[selectIndex].options">
					<el-input class="input" placeholder="编辑选项内容" v-model="TemplateList[selectIndex].options[index]" />
					<i class="el-icon-circle-plus-outline" @click="addItem(index+1)"></i>
					<i v-if="index > 0" class="el-icon-remove-outline" @click="deleteItem(index)"></i>
				</div>
			</div>
		</div>
		<div class="row">
			<span class="span">其他：</span>
			<el-checkbox v-model="TemplateList[selectIndex].required">必填项</el-checkbox>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			TemplateList: {
				type: Array
			},
			selectIndex: {
				type: Number
			}
		},
		data() {
			return {
				list: ['文本', '日期+时间', '单选框', '附件（附件以文件方式上传）'],
				checked: false,
				show: true,
				value:''
			}
		},
		methods: {
			//移除该组件
			deleteClick(id) {
				const key = this.TemplateList.filter(item => item.templateType == id).length
				if (key > 1) {
					this.$emit('deleteClick');
				} else {
					this.$message({
						message: '该组件只存在一条时，不支持删除操作！',
						type: 'warning'
					});
				}
			},
			
			//下移
			down(){
				this.$emit('down');
			},
			
			//上移
			up(){
				this.$emit('up');
			},
			
			//新增选项内容
			addItem(index){
				this.TemplateList[this.selectIndex].options.splice(index, 0, '')
			},
			
			//删除选项内容
			deleteItem(index){
				this.TemplateList[this.selectIndex].options.splice(index, 1)
			}
		}
	}
</script>

<style scoped>
	.control_div {
		width: 400px;
		display: flex;
		flex-direction: column;
		margin-left: 60px;
	}

	.row {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 20px;
	}
	
	.row_{
		display: flex;
		flex-direction: row;
		align-items: baseline;
	}
	
	.col{
		display: flex;
		flex-direction: column;
	}

	.span {
		width: 80px;
		justify-content: left;
	}

	.el-icon-delete {
		font-size: 20px;
		color: red;
	}

	.icon_div {
		display: flex;
		align-items: center;
		justify-content: center;
		background: #00A292;
		margin-right: 10px;
		width: 30px;
		height: 30px;
		border-radius: 20px;
	}

	.el-icon-bottom {
		font-size: 20px;
		color: #fff;
	}

	.el-icon-top {
		font-size: 22px;
		color: #fff;
		margin-right: 2px;
	}

	.input {
		width: 200px;
	}
	
	.item_div{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 20px;
	}
	
	.el-icon-circle-plus-outline{
		font-size: 22px;
		color: #d8d8d8;
		margin: 0 10px;
	}
	
	.el-icon-remove-outline{
		font-size: 22px;
		color: #d8d8d8;
	}
</style>